// extracted by mini-css-extract-plugin
export default {"l":"_107e042128"};